import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { Recipes } from "./pages/Recipes";
import { RecipeDetail } from "./pages/RecipeDetail";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Profile } from "./pages/Profile";
import { Favorites } from "./pages/Favorites";
import { Admin } from "./pages/Admin";
import { SetupAdmin } from "./pages/SetupAdmin";
import { Contact } from "./pages/Contact";

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen flex flex-col bg-bone-DEFAULT">
        <HashRouter>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/rezepte" element={<Recipes />} />
              <Route path="/rezept/:id" element={<RecipeDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registrieren" element={<Register />} />
              <Route path="/profil" element={<Profile />} />
              <Route path="/favoriten" element={<Favorites />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/setup-admin" element={<SetupAdmin />} />
              <Route path="/kontakt" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </HashRouter>
        <Toaster 
          position="top-center" 
          richColors 
          toastOptions={{
            style: {
              fontFamily: 'Manrope, sans-serif',
            },
          }}
        />
        <div className="grain-overlay" />
      </div>
    </AuthProvider>
  );
}

export default App;
